import React, { useState, useCallback } from 'react';
import s from './EarlyPay.module.css';

function fmt(n) {
  return '₹' + Math.round(n).toLocaleString('en-IN');
}

export default function EarlyPay() {
  const [invAmt, setInvAmt] = useState(1840000);
  const [days, setDays] = useState(13);
  const [rate, setRate] = useState(4.5);

  const disc = invAmt * (rate / 100) * (days / 365);
  const net = invAmt - disc;

  return (
    <div>
      <div className={s.epc}>
        {/* Header */}
        <div className={s.epcHead}>
          <div className={s.epcIcon}>
            <i className="ti ti-bolt" />
          </div>
          <div>
            <div className={s.epcTitle}>Early payment calculator</div>
            <div className={s.epcSub}>Supplier self-serve — see your advance offer instantly</div>
          </div>
        </div>

        {/* Body */}
        <div className={s.epcBody}>
          {/* LEFT: Inputs */}
          <div className={s.epcLeft}>
            <div className={s.epcField}>
              <div className={s.epcLabel}>Invoice amount (₹)</div>
              <input
                className={s.epcInput}
                type="number"
                value={invAmt}
                step={10000}
                onChange={e => setInvAmt(parseFloat(e.target.value) || 0)}
              />
            </div>

            <div className={s.epcField}>
              <div className={s.epcLabel}>Days to standard payment date</div>
              <div className={s.sliderRow}>
                <input
                  type="range" min={5} max={60} step={1}
                  value={days}
                  onChange={e => setDays(parseInt(e.target.value))}
                  className={s.slider}
                />
                <span className={s.sliderVal}>{days} days</span>
              </div>
            </div>

            <div className={s.epcField}>
              <div className={s.epcLabel}>Annual discount rate (%)</div>
              <div className={s.sliderRow}>
                <input
                  type="range" min={1} max={12} step={0.5}
                  value={rate}
                  onChange={e => setRate(parseFloat(e.target.value))}
                  className={s.slider}
                />
                <span className={s.sliderVal}>{rate.toFixed(1)}%</span>
              </div>
            </div>

            <div className={s.epcField}>
              <div className={s.epcLabel}>Your bank account</div>
              <select className={s.epcInput}>
                <option>ICICI ****4421 (primary)</option>
                <option>HDFC ****8871</option>
              </select>
            </div>
          </div>

          {/* RIGHT: Results */}
          <div className={s.epcRight}>
            <div className={s.epcResult}>
              <div className={s.erLabel}>Amount credited today</div>
              <div className={s.erVal}>{fmt(net)}</div>
              <div className={s.erSub}>{days} days early · save {rate.toFixed(1)}% p.a.</div>
            </div>

            <div className={s.epcBreakdown}>
              <div className={s.ebRow}>
                <span className={s.ebk}>Invoice total</span>
                <span className={s.ebv}>{fmt(invAmt)}</span>
              </div>
              <div className={s.ebRow}>
                <span className={s.ebk}>Discount amount</span>
                <span className={`${s.ebv} ${s.red}`}>− {fmt(disc)}</span>
              </div>
              <div className={s.ebRow}>
                <span className={s.ebk}>You receive</span>
                <span className={`${s.ebv} ${s.green}`}>{fmt(net)}</span>
              </div>
              <div className={s.ebRow}>
                <span className={s.ebk}>Effective cost</span>
                <span className={s.ebv}>{rate.toFixed(1)}% p.a.</span>
              </div>
              <div className={s.ebRow}>
                <span className={s.ebk}>Credit date</span>
                <span className={s.ebv}>Today, 3 Jul 2026</span>
              </div>
            </div>

            <button className={s.applyBtn}>
              Apply for early payment ↗
            </button>
          </div>
        </div>
      </div>

      <div className={s.noteBox}>
        <i className="ti ti-info-circle" />
        <div>
          Early payment is funded by CPCL's treasury or a financing partner. Suppliers with compliance score above 75 are eligible. The discount rate is dynamic based on invoice age, supplier credit rating, and current liquidity.
        </div>
      </div>
    </div>
  );
}
